import { render, staticRenderFns } from "./BenefitTranslations.vue?vue&type=template&id=7b3f189d"
import script from "./BenefitTranslations.vue?vue&type=script&lang=js"
export * from "./BenefitTranslations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports